import { MouseEvent, useState } from "react";
import { useGeneralHooks } from "../../../Hooks/hooks";
import useDialogHooks from "../../Dialog/dialog-hooks";

const useBusinessDashboardCard = () => {
    const { navigate,t } = useGeneralHooks();
    const [anchor, setAnchor] = useState<null | HTMLElement>(null);
    const { open, onOpen, onClose } = useDialogHooks();
    const baseURL = process.env.REACT_APP_API_KEY;

    const handleMoreIconClick = (e: MouseEvent<HTMLImageElement>) => {
        e.stopPropagation();
        setAnchor(anchor ? null : e.currentTarget);
    };

    const handleCardClick = (id: number) => {
        navigate(`/my_business/${id}`);
    };

    const handleMouseLeaveContainer = () => {
        setAnchor(null);
    };

    const handlePopperMouseEnter = () => {
        setAnchor(anchor);
    };

    const handlePopperMouseLeave = () => {
        setAnchor(null);
    };

    const openPopper = Boolean(anchor);
    const id = openPopper ? 'simple-popup' : undefined;

    return {
        t,
        open,
        anchor,
        onOpen,
        onClose,
        handleMoreIconClick,
        handleCardClick,
        handleMouseLeaveContainer,
        handlePopperMouseEnter,
        handlePopperMouseLeave,
        openPopper,
        id,
        baseURL
    }
};

export default useBusinessDashboardCard